import { Input } from "./ui/input";
import { Search } from "lucide-react";
import { SEARCH_PLACEHOLDER } from "../lib/caseSearch";

export function CaseFilterBar({ q, setQ, filter, setFilter, options, counts, children }) {
  return (
    <div className="mt-5 space-y-3" data-testid="case-filter-bar">
      <div className="flex gap-2 flex-wrap items-center">
        <div className="relative flex-1 min-w-[240px] max-w-md">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <Input data-testid="case-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder={SEARCH_PLACEHOLDER} className="pl-9" />
        </div>
        {children}
      </div>
      <div className="flex gap-1.5 flex-wrap">
        {options.map(([key, label]) => (
          <button key={key} type="button" onClick={() => setFilter(key)} data-testid={`case-filter-${key}`}
            className={`text-xs font-medium px-3 py-1.5 rounded-full border transition-colors ${filter === key ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"}`}>
            {label} <span className="opacity-70">({counts[key] ?? 0})</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export function CaseIds({ c }) {
  const p = c.patient || {};
  return (
    <span className="text-xs text-slate-500 flex flex-wrap gap-x-3" data-testid={`case-ids-${c.id}`}>
      {c.case_number && <span className="font-mono font-semibold text-slate-700">{c.case_number}</span>}
      {p.file_no && <span>File {p.file_no}</span>}
      {p.phone && <span dir="ltr">{p.phone}</span>}
    </span>
  );
}
